import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getRentedItems } from 'portal-modules/rentable-items/api/api'
import { requestRentableItems } from './rentableItems'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
const REQUEST_RENTED_ITEMS = 'rp/rentableItems/REQUEST_RENTED_ITEMS'
const RECEIVE_RENTED_ITEMS = 'rp/rentableItems/RECEIVE_RENTED_ITEMS'

// reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVE_RENTED_ITEMS:
      return payload
    default:
      return state
  }
}

// action creators
export const requestRentedItems = () => ({ type: REQUEST_RENTED_ITEMS })

// sagas
function* fetchRentedItems() {
  const needsRentableItems = yield select(
    ({ rentableItems }) => !Object.keys(rentableItems).length,
  )
  if (needsRentableItems) yield put(requestRentableItems())
  const { rented_items = [] } = yield call(getRentedItems)

  if (rented_items.length) {
    yield put({
      type: RECEIVE_RENTED_ITEMS,
      payload: Object.values(rented_items).reduce(
        (obj, item) => ({
          ...obj,
          [item.id]: item,
        }),
        {},
      ),
    })
  }
}

function* watchRequestedRentedItems() {
  yield takeLatest(REQUEST_RENTED_ITEMS, function* (action) {
    const { isLeaseAndRentWordReplaced } = yield select(
      ({ productPermissions }) => ({
        isLeaseAndRentWordReplaced:
          productPermissions?.replace_lease_and_rent || false,
      }),
    )

    const dynamicMessage = isLeaseAndRentWordReplaced
      ? __('Finding your items')
      : __('Finding your rented items')

    yield* createRequestSaga(fetchRentedItems, {
      key: 'rented_items',
      message: dynamicMessage,
    })(action)
  })
}

export const sagas = [watchRequestedRentedItems]
